export default {
  name: '导航',
  btn: {
    addExternalLink: '添加外链',
    addInnerLink: '添加内链'
  },
  label: {
    link: '链接:',
    backgroundColor: '背景颜色',
    textColor: '字体颜色',
    activeColor: '活动页面颜色',
    hoverColor: '鼠标悬浮颜色（电脑端）',
    btnColor: '按钮颜色（手机端）'
  },
  placeholder: {
    linkName: '链接名称',
    linkUrl: '链接url',
    selectInnerLink: '选择内链',
    selectInnerPage: '选择内部页面'
  },
  openInNewTab: '在新窗口打开'
}
